import { useState } from 'react';
import { NButton, NInput, useToast } from 'nayan';
import { deleteAccount } from '../../services/AuthService.ts';

const DeleteAccount = () => {
  const toast = useToast();
  const [email, setEmail] = useState('');

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!email) {
      return toast('You have to enter valid email to continue.');
    }
    deleteAccount({ email: email })
      .then(res => toast(res.data.message))
      .catch((err: any) => toast(err.message));
  };

  return (
    <div className="sm:w-full md:max-w-[400px] p-3 mx-auto mt-5">
      <form onSubmit={onSubmit}>
        <div className="mb-5">
          For deleting your account immidiatly, You can always login to Kidster mobile application and Goto: Account - Settings - Delete Account. this
          will remove your account and associated data immidiatly.
        </div>
        <NInput className="mb-3 card-input mt-5" label="Email" type="email" onChange={e => setEmail(e.target.value)} required={true} />
        <NButton type="submit" className="w-full mb-3">
          DELETE ACCOUNT
        </NButton>
      </form>
    </div>
  );
};

export default DeleteAccount;
